import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import NavDropdown from 'react-bootstrap/NavDropdown';
import MenuContext from "../store/menu-context";


const NavDropDownItem = (props) => {
    // console.log(JSON.stringify(props));
    const location = useLocation();
    const { hash, pathname, search } = location;

    // const navObject = props.menuItems;
    const navObject = useContext(MenuContext);
    // console.log('Inside NavDropDownItem');
    // console.log(navObject);

    // console.log("props.menuItems", props.menuItems);
    const renderNavItem = (dDitem, item, dDitemId) => {
        // console.log("recieved: ", dDitem, item, dDitemId);
        if(dDitem !== "title" && dDitem.includes("separator")){
            return(<NavDropdown.Divider />)
        }else if(dDitem !== "title"){
            // console.log("dDitem: ", navObject[item][dDitem]);
            // console.log("dDitem: ", navObject[item][dDitem]);
            var jsonItem = navObject[item][dDitem];
            // console.log("source: ", navObject[item][dDitem]["source"]);
            var itemSource = navObject[item][dDitem]["source"]
            // console.log("target: ", navObject[item][dDitem]["target"]);
            var itemTarget = navObject[item][dDitem]["target"]
            let finalTarget = "";
            if(itemTarget.includes("self")){
                finalTarget = "self"
            }else{finalTarget = "blank"}
            if(itemSource.includes("externalcontent")){
                return(
                    <NavDropdown.Item  
                        as={Link} 
                        to={itemSource + "?target=" + finalTarget + "&source=" + pathname}
                        target="_self"
                        key={dDitemId} 
                        onClick={props.collapseMe}
                    >{dDitem}
                </NavDropdown.Item>
                )
            }else {
                return(
                    <NavDropdown.Item  
                        as={Link} 
                        to={itemSource}
                        target={itemTarget}
                        key={dDitemId} 
                        onClick={props.collapseMe}
                    >{dDitem}
                </NavDropdown.Item>
                )
            }
        }
    };

    const renderNavDropDown = () => {
        return (
            <NavDropdown title={navObject[props.item]['title']} key={props.menuItemId}>
                {Object.keys(navObject[props.item])?.map((dDitem, dDitemId) => (
                    renderNavItem(dDitem, props.item, dDitemId)
                    ))    
                }
            </NavDropdown>
        )
    }

   return (
    <>
    {navObject && renderNavDropDown()}
    </>

   )
}             

export default NavDropDownItem;

